import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VerificationMethod } from '../../dto/login.dto';

@Component({
  selector: 'app-verify-method',
  templateUrl: './verify-method.component.html',
  styleUrls: [
    './verify-method.component.scss',
    '../../entrance-group.scss',
  ],
})
export class VerifyMethodComponent {

  @Input() method: {id: VerificationMethod; name: string};
  @Input() isActive: boolean;
  @Output() changeMethod = new EventEmitter<VerificationMethod>();

  onClick() {
    this.changeMethod.emit(this.method.id);
  }
}
